function parsePath (path) {
    const match = /([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}|[a-f0-9]{32})(\/(folder)\/(.*))?\/$/.exec(path);
    return match && {
        uuid: match[1],
        assetType: match[3],
        lookup: match[4]
    };
}

function folderFromLookup (lookup) {
    return decodeURIComponent(lookup).replace(/^p:/, '').replace(/\/*$/, '');
}

function getBase (path, linkUuid) {
    return path.substr(0, path.indexOf(linkUuid));
}

function isLinkView () {
    return window.location.pathname.startsWith('/links') &&
        parsePath(window.location.pathname);
}

export {
    parsePath,
    folderFromLookup,
    getBase,
    isLinkView
};
